import { useEffect } from 'react'

// Solo memoria de React. Nunca localStorage/IndexedDB ni caché deportiva.
export function useEvaluationDraftGuard(dirty: boolean) {
  useEffect(()=>{
    if(!dirty)return
    const unload=(e:BeforeUnloadEvent)=>{e.preventDefault();e.returnValue=''}
    const click=(e:MouseEvent)=>{
      const target=e.target instanceof Element?e.target:null
      const leaving=target?.closest('.nav-item,.bottom-nav-button,.subtab-btn,.account-logout-btn,[data-evaluation-leave],[aria-label="Cerrar modal"]')
      const backdrop=target?.classList.contains('modal-backdrop')
      if((leaving||backdrop)&&!window.confirm('Hay resultados pendientes de guardar. ¿Deseas descartarlos y salir?')){e.preventDefault();e.stopPropagation()}
    }
    const key=(e:KeyboardEvent)=>{if(e.key==='Escape'&&!window.confirm('Hay resultados pendientes de guardar. ¿Deseas descartarlos y cerrar?')){e.preventDefault();e.stopPropagation()}}
    window.addEventListener('beforeunload',unload);document.addEventListener('click',click,true);window.addEventListener('keydown',key,true)
    return ()=>{window.removeEventListener('beforeunload',unload);document.removeEventListener('click',click,true);window.removeEventListener('keydown',key,true)}
  },[dirty])
}
